"use client";

import { openConsentBanner } from "@/lib/consent";

/**
 * Footer "Cookie Preferences" link. Reopens the consent banner so visitors
 * can change a previously saved Accept/Reject choice. Client component so
 * the (server-rendered) Footer can stay a server component.
 */
export default function CookiePreferencesLink() {
  return (
    <button
      type="button"
      onClick={openConsentBanner}
      className="text-gray-400 hover:text-white text-[10px] uppercase tracking-[0.25em] font-semibold transition-colors duration-150"
    >
      Cookie Preferences
    </button>
  );
}
